import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { LanguageSwitcher, Logo } from '../components/brand';

export function AuthLayout() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-screen lg:grid-cols-[1fr_1.1fr]">
      <div className="flex flex-col bg-white px-4 py-6 sm:px-10">
        <div className="flex items-center justify-between">
          <Logo />
          <LanguageSwitcher compact />
        </div>
        <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-10">
          <Outlet />
        </div>
      </div>
      <div className="relative hidden overflow-hidden bg-slate-900 lg:flex lg:flex-col lg:justify-center lg:px-16">
        <div className="absolute -top-24 -right-24 size-96 rounded-full bg-brand opacity-30 blur-3xl" />
        <div className="relative max-w-md">
          <p className="text-sm font-semibold tracking-wide text-brand-200 uppercase">High CRM</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-white">{t('auth.side.title')}</h2>
          <ul className="mt-8 space-y-4">
            {(['one', 'two', 'three', 'four'] as const).map((k) => (
              <li key={k} className="flex gap-3 text-slate-300">
                <CheckCircle2 className="mt-0.5 size-5 shrink-0 text-emerald-400" />
                <span>{t(`auth.side.${k}`)}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
